import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { useUpdateSectionStaysCache } from "../../useFetchSectionStays";

export const useUpdateSectionStay = ({ sectionId }: { sectionId: string }) => {
  const { updateSectionStaysCache } = useUpdateSectionStaysCache({
    sectionId,
  });

  return useBoronMutation(
    async ({
      stayId,
      params,
    }: {
      stayId: string;
      params: { entered_at: string; exited_at: string };
    }) =>
      await boronClient.PATCH(
        "/api/v1/sections/{section_id}/stays/{stay_hashid}",
        {
          params: {
            path: {
              section_id: sectionId,
              stay_hashid: stayId,
            },
          },
          body: {
            stay: params,
          },
        },
      ),
    {
      onSuccess: (data) => {
        updateSectionStaysCache(data.stay);
      },
    },
  );
};
